module.exports = __webpack_public_path__ + "static/media/IMG_7786.59c06a94.png";